import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ListItem from '@material-ui/core/ListItem';

import Can from '~/contexts/Can';

import Logo from './components/Logo';
import User from './components/User';
import Item from './components/Item';
import TermsList from './components/TermsList';

import useStyles from './styles';
import makeItems from './utils/makeItems';

function Menu({ open, setOpen }) {
  const classes = useStyles();
  const { t } = useTranslation();
  const items = makeItems(t);

  return (
    <Drawer
      variant="permanent"
      classes={{
        root: clsx('no-printable', classes.drawer),
        paper: clsx(
          'menu',
          classes.drawerPaper,
          !open && classes.drawerPaperClose
        ),
      }}
      open={open}
    >
      <List>
        {!open && (
          <ListItem onClick={() => setOpen(!open)}>
            <IconButton
              edge="start"
              color="inherit"
              aria-label="Open drawer"
              onClick={() => setOpen(!open)}
              className={clsx(classes.icon)}
            >
              <MenuIcon style={{ color: '#ffffff' }} />
            </IconButton>
          </ListItem>
        )}
        {!open && <Divider classes={{ root: classes.divider }} />}

        <Logo open={open} setOpen={setOpen} />
        {open && <TermsList />}
        <Divider classes={{ root: classes.divider }} />

        <User open={open} />
        <Divider classes={{ root: classes.divider }} />

        {items.map((item, key) => {
          if (item.external) {
            return <Item open={open} key={key} item={item} />;
          } else {
            return (
              <Can key={key} I="list" a={item?.route?.can}>
                <Item open={open} item={item} />
              </Can>
            );
          }
        })}
      </List>
    </Drawer>
  );
}

Menu.propTypes = {
  open: PropTypes.bool.isRequired,
};

export default Menu;
